export default __webpack_public_path__ + "static/media/VST.00976710.svg";